var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconSvgModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 47 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74666 54.0533C7.88467 56.8304 10.1602 58.9997 12.9461 58.9997H34.0527C36.8385 58.9997 39.1143 56.8305 39.2521 54.0533L42.2923 19.0879H4.70642L7.74666 54.0533ZM28.7053 27.7644H32.1759V46.8526H28.7053V27.7644ZM21.7641 27.7644H25.2347V46.8526H21.7641V27.7644ZM14.823 27.7644H18.2935V46.8526H14.823V27.7644Z",
    fill: "#FF4949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1763 8.67647V5.20588C32.1763 2.33547 29.8411 0 26.9705 0H20.0293C17.1589 0 14.8234 2.33547 14.8234 5.20588V8.67647H0.94104V15.6176H46.0587V8.67647H32.1763ZM18.294 8.67647V5.20588C18.294 4.24904 19.0726 3.47059 20.0293 3.47059H26.9705C27.9274 3.47059 28.7057 4.24904 28.7057 5.20588V8.67647H18.294Z",
    fill: "#FF4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconSvgModel);
export default __webpack_public_path__ + "static/media/deleteIconSVGModel.0704ae8280213da29b87d182893098f3.svg";
export { ForwardRef as ReactComponent };